import { FC } from "react";

import {
  AreasMapToggleButton,
  BulkGridSelectionControl,
  EditGridColumnButton,
  PanelTopStatCommon,
} from "@ryde/layout";
import { usePageContext } from "@ryde/redux";
import { isEntityWithoutBulkActions, useIsMobile } from "@ryde/shared";

import { AreasPanelTopWrapper } from "./areas.panels-top.styled";

export const AreasPanelTop: FC = () => {
  const { entity } = usePageContext();
  const { isMobile } = useIsMobile();
  const showBulkGridSelection = !isEntityWithoutBulkActions(entity);

  if (isMobile) {
    return null;
  }

  return (
    <AreasPanelTopWrapper>
      {showBulkGridSelection && <BulkGridSelectionControl />}
      {!isMobile && <AreasMapToggleButton />}

      <div className="panelTopRight">
        <PanelTopStatCommon />
        <EditGridColumnButton />
      </div>
    </AreasPanelTopWrapper>
  );
};
